define('utils/ajax-util',['jquery', 'utils/toast'], function ($, toast) {
  /**
   * @class Cart
   */
  return (function () {
    /**
     * @constructor
     */
    function AjaxUtil() { }

    AjaxUtil.prototype.notifyError = function (xhr, status, error) {
      if (status === 'abort') return;
      toast.queueError(error || status, 5000);
    };

    AjaxUtil.prototype.ajax = function (type, apiString, data, success, error) {
      return $.ajax({
        type: type,
        url: apiString,
        data: data,
        success: success,
        error: error || this.notifyError
      });
    };

    AjaxUtil.prototype.ajaxWithFormData = function (apiString, formData, success, error) {
      return $.ajax({
        type: 'POST',
        url: apiString,
        data: formData,
        success: success,
        error: error || this.notifyError,
        cache: false,
        contentType: false,
        processData: false
      });
    };

    AjaxUtil.prototype.post = function (apiString, data, success) {
      return this.ajax('POST', apiString, data, success);
    };

    AjaxUtil.prototype.get = function (apiString, data, success) {
      return this.ajax('GET', apiString, data, success);
    };

    AjaxUtil.prototype.delete = function (apiString, data, success) {
      return this.ajax('DELETE', apiString, data, success);
    };

    return new AjaxUtil();
  })();
});

